/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { useEffect, useState } from 'react';
import { PrismLight as SyntaxHighlighter } from 'react-syntax-highlighter';

import { type LanguageProp, loadLanguage } from '../code-languages';

/**
 * Load the code highlighting language for the given language.
 * Defaults to 'text' if no language is provided.
 */
export const useCodeLanguage = (language?: LanguageProp | 'text') => {
  const [loadedLanguage, setLoadedLanguage] = useState<LanguageProp | 'text'>(
    'text',
  );

  useEffect(() => {
    if (language === undefined || language === 'text') {
      setLoadedLanguage('text');
      return;
    }

    loadLanguage(language)
      .then((module) => {
        SyntaxHighlighter.registerLanguage(language, module.default);
        setLoadedLanguage(language);
      })
      // TODO: add visual feedback for the user
      .catch((err) => console.error(err));
  }, [language]);

  return loadedLanguage;
};
